// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const OrganizationType = {
  Global: {
    Name: 'Global',
    Value: 'global',
    Icon: 'Globe',
  },
  Florist: {
    Name: 'Florist',
    Value: 'florist',
    Icon: 'Flower2',
  },
} as const

export type OrganizationTypeValue =
  (typeof OrganizationType)[keyof typeof OrganizationType]['Value']
